import React from 'react';
import { RateCardModel } from '@utmost.co/enterprise-models';
import { useFormatAddressAsSingleLine } from 'src/utils/useFormatAddressAsSingleLine';

interface Props {
  rateCard?: RateCardModel;
}
const LocationDetails: React.FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const formatAddressAsSingleLine = useFormatAddressAsSingleLine();

  return <>{rateCard?.remoteWorkAddress ? formatAddressAsSingleLine(rateCard?.remoteWorkAddress) : '-'}</>;
};
export default LocationDetails;
